import { Row, Spacer } from "../../../components/Layout/Layout";
import useTranslations from "../../../core/i18n/useTranslations";
import Button from "../../../ui-lib/components/Button/Button";
import { observer } from "mobx-react";
import ObservationIdentifiersPage from "../../../components/ObservationIdentifiers/ObservationIdentifiersPage";
export const PAGE_ID = "adminportal/location/observation-identifiers";

const ObservationIdentifiers = () => {
  const t = useTranslations();
  return (
    <ObservationIdentifiersPage pageId={PAGE_ID}>
      {(onCreate) => (
        <>
          <Spacer size={8} />
          <Row type="space" align="center" className="flex0 w-100">
            <div>
              <h1>{t("Locations:oi_page_title")}</h1>
              <Spacer size={8} />
              <p>{t("Locations:oi_page_description")}</p>
            </div>
            <Spacer size={8} />
            <Button
              variant="secondary"
              size="extraSmall"
              text={t("Locations:oi_add_observation_identifiers")}
              onClick={onCreate}
            />
          </Row>
          <Spacer size={32} />
        </>
      )}
    </ObservationIdentifiersPage>
  );
};

export default observer(ObservationIdentifiers);
